import { path, prop } from 'ramda';
import React, { useMemo } from 'react';
import { FormSpy } from 'react-final-form';
import { Loader } from 'js/components/common/Loader';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { Form as CommonForm } from 'js/components/common/Form/Form';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';
import { ChangeFormField } from 'js/components/common/ChangeForm/components/ChangeFormField';
import { useUserSelector } from 'js/store/hooks';

import { useDynamicReducerSelector } from '../../store';
import {
    FORM_VALIDATION_CONFIG,
    FORM_FIELD_PASSPORT_NUMBER,
    FORM_FIELD_PIN,
    FORM_SUBMIT_BUTTON,
    FORM_FIELD_DATE_OF_BIRTH
} from './constants';

import style from './Form.scss';

export const Form = ({ onSubmit }) => {
    const { system } = useComponentConfig();
    const translate = useComponentTranslations();
    const retailCardNumber = useDynamicReducerSelector(prop('retailCardNumber'));
    const birthDate = useUserSelector(path(['userDetails', 'birthDate']));

    const initialValues = useMemo(() => ({
        passportNumber: retailCardNumber,
        birthday: birthDate
    }), [retailCardNumber, birthDate]);

    if (!retailCardNumber) {
        return <Loader />;
    }

    return (
        <CommonForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationConfig={FORM_VALIDATION_CONFIG}
            render={({ handleSubmit }) => (
                <form
                    className={style.form}
                    onSubmit={handleSubmit}
                >
                    <div className={style.title}>{translate('title', [translate(`system.${system}`)])}</div>
                    <div className={style.description}>{translate('description', [translate(`system.${system}`)])}</div>
                    <FormSpy
                        subscription={{ submitError: true }}
                        render={({ submitError }) => submitError ?
                            <ErrorMessage className={style.error} error={submitError} animate={true} />
                            : null
                        }>
                    </FormSpy>
                    <ChangeFormField field={FORM_FIELD_PASSPORT_NUMBER} />
                    <ChangeFormField field={FORM_FIELD_DATE_OF_BIRTH} />
                    <ChangeFormField field={FORM_FIELD_PIN} />
                    <ChangeFormField field={FORM_SUBMIT_BUTTON} className={style.submit} />
                </form>
            )}
        />
    );
};
